import { useEffect, useRef, useState } from 'react';

// Components
import {
  ButtonCustom,
  TextCustom,
  AlertCustom,
  LoaderCotizar,
} from '../../atoms';
import { PreguntasForm } from '../../molecules';
import {
  ModalAlertas,
  ModalEnfermedades,
  ModalOncologico,
  ModalTerminos,
} from '../../organisms';
import { ModalControlValidacion } from '../../organisms';
import { apiEncontrarPersonaListaControl } from '../../../services/apis/Lista Control/listaControl';
import { renderContactarControlValidacion } from '../../../common/constants/textoModales.js';

// Hooks
import { useApp, useCotizador, useForm } from '../../../hooks/others';

//services/api
import {
  apiActualizarOportunidad,
  apiGetPersona,
} from '../../../services/apis';

//constants/utils
import { renderBoldText } from '../../../common/constants';
import {
  calcularEdad,
  capitalizarPalabra,
  changeQueryParam,
  generarParamsOportunidad,
} from '../../../core/utils';

// Validations
import { formValidDatosPersonales } from '../../../core/validations/formValidDatosPersonales';
import { validateUniqueIdentificationsSet } from '../../../core/utils/functions.js';
import { useGetSeguros } from '../../molecules/CardSeguroTitulo/query.js';
import { ModalPleniSalud } from '../ModalPleniSalud/index.jsx';
import { ModalSmsCode } from '../ModalSmsCode/index.jsx';
import { useGenerateOTP } from '../../../services/apis/formularioOTP/formularioOTP.hook.js/index.js';

const PasoEmision = () => {
  const {
    dataCotizar,
    paso,
    pasos,
    handleSiguientePaso,
    idOportunidad,
    handleRegresarPaso,
    handleValidBeneficiarios,
    setDataCotizar,
    isRecuperandoCotizacion,
    idCotizacion,
    cargando,
    setCargando,
    pasoActual,
    setPasoActual,
    setPasoAnterior,
    setRechazado,
    pasoAnterior,
    mostrarCampos,
    setComprandoOtroSeguro,
    setMaskedData,
  } = useCotizador();

  const { recaptchaRef } = useApp();
  const [showAlert, setShowAlert] = useState(false);
  const [formData, setFormData] = useState('');
  const [formDataError, setFormDataError] = useState('');
  const [modal, setModal] = useState(false);
  const [modalRequisitos, setModalRequisitos] = useState(false);
  const [modalValidacion, setModalValidacion] = useState(false);
  const [beneficiarios, setBeneficiarios] = useState(false);
  const [modalBeneficiarios, setModalBeneficiarios] = useState(false);
  const [modalPorcentaje, setModalPorcentaje] = useState(false);

  const [preexistencias, setPreexistencias] = useState(
    dataCotizar?.valoresModales?.ENFPRE || [],
  );

  const [modales, setModales] = useState(false);
  const [openModalOTP, setOpenModalOTP] = useState(false);
  const paramsCodeOTP = {
    idOportunidad: idOportunidad,
    telefono: formData.telefono,
    valueAccepted: [...preexistencias],
  };

  const [modalState, setModalState] = useState({
    requisitos: true,
    validacion: false,
    beneficiarios: false,
    smsCode: false,
  });

  function changeModalOpen(key, open) {
    setModalState(prevState => ({ ...prevState, [key]: open }));
  }

  const [recuperar, setRecuperar] = useState(false);
  const [mensajeError, setMensajeError] = useState({
    titulo: '',
    mensaje: '',
  });

  const [loaderInput, setLoaderInput] = useState(false);
  const [maskTel, setMaskTel] = useState('####-####');
  const [alert, setAlert] = useForm({
    title: '',
    description: '',
    severity: 'info',
  });
  const debounceTimerRef = useRef(null);

  const handleSiguientePasoDebounced = () => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      handleSiguientePaso();
      setCargando(false);
    }, 300);
  };

  useEffect(() => {
    setPasoAnterior(pasoActual);
    setPasoActual(paso);
  }, [paso, pasoActual, setPasoActual, setPasoAnterior]);

  useEffect(() => {
    if (paso === 4) {
      // eslint-disable-next-line no-undef

      const dataF = pasos[paso - 1]?.formData;
      const dataP = dataCotizar?.datosPersonales;

      if (pasoAnterior < 4) delete dataP['beneficiarios'];
      if (dataP?.beneficiarios && dataP.beneficiarios.length < 1)
        delete dataP['beneficiarios'];
      setBeneficiarios(dataF?.beneficiarios !== undefined ? true : false);
      setFormData({ ...dataF, ...dataP });
      setFormDataError(pasos[paso - 1]?.formDataError ?? '');
      setCargando(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paso, isRecuperandoCotizacion]);

  useEffect(() => {
    if (dataCotizar.datosPersonales) {
      const dataP = dataCotizar.datosPersonales;

      if (dataP.telefono.includes('*')) {
        setMaskTel('****-####');
      }
    }
  }, [paso, setMaskTel, dataCotizar.datosPersonales]);

  useEffect(() => {
    if (paso === 4 && isRecuperandoCotizacion) {
      changeQueryParam('paso', paso);
    }
  }, [paso, isRecuperandoCotizacion]);

  const aceptacionModalEmisionPoliza = async resp => {
    setModalRequisitos(false);
    setCargando(true);
    const respuesta = async () => {
      const respp = await apiEncontrarPersonaListaControl({
        id_persona: formData.numeroIdentificacion,
      });
      return respp;
    };
    const respp = await respuesta();

    if (respp.data.no_cotizar) {
      setModalValidacion(true);
    } else {
      try {
        const token = await recaptchaRef.current.executeAsync();

        if (token) {
          const requisitosCodigos = {
            AEP: '',
            DDP: '',
            DDPO: '',
            ENFPRE: preexistencias,
          };

          if (resp) {
            //* si acepta la emision de la poliza la etapa se pasa a emision
            //codigos de requisitos
            if (dataCotizar.seguro.codigo === 'SEG-ONC') {
              requisitosCodigos.AEP = 'aceptado';
              requisitosCodigos.DDP = 'aceptado';
              requisitosCodigos.DDPO = 'aceptado';
            } else {
              requisitosCodigos.AEP = 'aceptado';
              requisitosCodigos.DDP = 'aceptado';
            }

            const paramsOportunidad = generarParamsOportunidad(
              idOportunidad,
              idCotizacion,
              'Los documentos necesarios han sido aprobados. Se procederá a generar la póliza una vez recibido el pago.',
              'ACEPTACION',
              'EMI',
              'DOC',
              requisitosCodigos,
            );

            const newParamsOportunidad = {
              ...paramsOportunidad,
              datosPersonales: dataCotizar?.datosPersonales,
            };

            const { success: isExito } =
              await apiActualizarOportunidad(newParamsOportunidad);

            if (isExito) {
              handleSiguientePasoDebounced();
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleValue = async (val = '', valForm) => {
    if (valForm === 'numeroIdentificacion') {
      setFormDataError({ ...formDataError, numeroIdentificacionError: false });
      let newData = { ...formData };
      const tipoID = newData['tipoIdentificacion'];
      //cuando el numero de indentificacion sea igual a 9 se manda llamar el api
      if (val.length === 9) {
        setLoaderInput(true);
        const { data, success } = await apiGetPersona({
          identificacion: val,
          tipo: tipoID ? tipoID : '0',
        });
        let commonData = {};

        if (success) {
          setLoaderInput(false);

          setRecuperar(true);

          commonData = {
            tipoIdentificacion: renderValueIdentidad(
              data.tipoIdentificacion
                ? data.tipoIdentificacion
                : formData.tipoIdentificacion || '0',
            ),
            numeroIdentificacion: val,
            primerNombre: capitalizarPalabra(data.primerNombre) || '',
            segundoNombre: capitalizarPalabra(data.segundoNombre) || '',
            primerApellido: capitalizarPalabra(data.primerApellido) || '',
            segundoApellido: capitalizarPalabra(data.segundoApellido) || '',
            correo: data.correo,
            telefono: data.telefono,
            fechaNacimiento:
              dataCotizar?.datosPersonales?.fechaNacimiento ||
              data?.fechaNacimiento ||
              '',
            edad:
              calcularEdad(
                dataCotizar?.datosPersonales?.fechaNacimiento ||
                  data?.fechaNacimiento,
              ) || '',
          };
        } else {
          setRecuperar(false);

          commonData = {
            tipoIdentificacion: renderValueIdentidad(tipoID ? tipoID : '0'),
            numeroIdentificacion: val,
            primerNombre: '',
            segundoNombre: '',
            primerApellido: '',
            segundoApellido: '',
            correo: '',
            telefono: '',
            fechaNacimiento:
              dataCotizar?.datosPersonales?.fechaNacimiento || '',
            edad: dataCotizar?.datosPersonales?.fechaNacimiento
              ? calcularEdad(dataCotizar?.datosPersonales?.fechaNacimiento)
              : '',
          };
          setModal(true);
          setAlert({
            title: '¡Información no encontrada!',
            description:
              'No pudimos completar automáticamente tus datos. Asegúrate de llenar todos los campos obligatorios antes de continuar.',
            severity: 'warning',
          });
          setTimeout(() => {
            setModal(false);
          }, 4000);
        }

        setFormData({
          ...formData,
          ...commonData,
        });

        setLoaderInput(false);
        setComprandoOtroSeguro(false);
      } else {
        let newData = { ...formData };
        newData[valForm] = val;
        setFormData(newData);
      }

      return;
    }
    if (valForm === 'tipoIdentificacion') {
      const commonData = {
        tipoIdentificacion: val,
        numeroIdentificacion: '',
        primerNombre: '',
        segundoNombre: '',
        primerApellido: '',
        segundoApellido: '',
        correo: '',
        telefono: '',
      };

      if (dataCotizar.seguro.codigo === 'SEG-V') {
        setFormData({
          ...formData,
          ...commonData,
          fechaNacimiento: '',
          edad: '',
        });
      } else {
        setFormData({
          ...formData,
          ...commonData,
        });
      }
      return;
    }
    if (valForm === 'fechaNacimiento') {
      const edadCalculada = calcularEdad(val);

      setFormData({
        ...formData,
        edad: edadCalculada,
        fechaNacimiento: val,
      });

      setDataCotizar(prevState => ({
        ...prevState,
        datosPersonales: {
          ...prevState.datosPersonales,
          ...formData,
          edad: edadCalculada,
          fechaNacimiento: val,
        },
      }));

      return;
    }

    if (valForm === 'primerNombre' || valForm === 'primerApellido') {
      if (val.length !== '') {
        setFormDataError({ ...formDataError, [valForm + 'Error']: false });
      }
    }

    if (valForm === 'correo') {
      if (val.length !== 0) {
        setFormDataError({ ...formDataError, [valForm + 'Error']: false });
      }

      let newData = { ...formData };
      newData[valForm] = val;
      setFormData(newData);
      setMaskedData(prev => ({ ...prev, correo: val }));
      return;
    }

    if (valForm === 'telefono') {
      if (val.length !== 0) {
        setFormDataError({ ...formDataError, [valForm + 'Error']: false });
      }

      if (!val.includes('*')) {
        setMaskTel('####-####');
      }

      if (recuperar) {
        setMaskTel('****-####');
        setRecuperar(false);
      }

      if (val.length === 0) {
        formData.telefono = '';
        setMaskTel('####-####');

        return;
      }

      if (val.length === 9) {
        setFormData(prev => ({ ...prev, telefono: val }));
      }
      return;
    }

    let newData = { ...formData };
    newData[valForm] = val;
    setFormData(newData);
  };

  const handleSubmit = async (dependientes = []) => {
    let mostrarModales = true;

    setDataCotizar(prevState => ({
      ...prevState,
      datosPersonales: {
        ...prevState.datosPersonales,
        ...formData,
      },
    }));

    if (
      (dataCotizar?.seguro?.codigo === 'SEG-PLENI' || dataCotizar?.seguro?.codigo === 'SEG-PLENI-HILC') &&
      dependientes.length > 0
    ) {
      setDataCotizar(prevState => ({
        ...prevState,
        datosPersonales: {
          ...prevState.datosPersonales,
          dependientes: dependientes,
        },
      }));

      if (
        validateUniqueIdentificationsSet([
          ...dependientes,
          dataCotizar?.datosPersonales,
        ])
      ) {
        return setShowAlert(true);
      }
    }

    const infoHandleValidForm = handleValidForm();
    mostrarModales = infoHandleValidForm;

    if (infoHandleValidForm) {
      if (beneficiarios) {
        const validBeneficiario = handleValidBeneficiarios();

        if (!validBeneficiario) {
          //lanzando un error si hay en los beneficiarios
          setAlert({
            title: '¡Datos del beneficiario son obligatorios!',
            description:
              'Para continuar, es necesario completar todos los datos del beneficiario.',
            severity: 'error',
          });
          mostrarModales = false;
          setModal(true);
          return mostrarModales;
        } else if (validBeneficiario.error === 'invalid') {
          if (validBeneficiario.porcentaje < 100) {
            setMensajeError({
              titulo: '¡Completa el porcentaje de participación!',
              mensaje:
                'Agrega otro beneficiario para completar el porcentaje de participación.',
            });
            mostrarModales = false;
          } else if (validBeneficiario.porcentaje > 100) {
            setMensajeError({
              titulo: '¡Porcentaje de participación fuera de rango!',
              mensaje:
                'Tu porcentaje de participacion esta por arriba del permitido.',
            });
            mostrarModales = false;
          } else {
            setMensajeError({
              titulo: 'Límite de beneficiarios alcanzado!',
              mensaje:
                'No es posible agregar más beneficiarios, el límite de porcentaje de participación ha sido alcanzado.',
            });
            mostrarModales = false;
          }

          setModalPorcentaje(true);
          return mostrarModales;
        } else if (validBeneficiario.error === 'sbeneficiarios') {
          setAlert({
            title: '¡Revisa tu porcentaje de participación!',
            description: 'Porcentaje de participación es incorrecto.',
            severity: 'error',
          });
          setModal(true);
          mostrarModales = false;

          return mostrarModales;
        } else if (validBeneficiario.error === 'invalidIdentification') {
          setAlert({
            title: '¡Número de identificación incorrecto!',
            description: 'Las identidades deben ser diferentes.',
            severity: 'error',
          });
          setModal(true);
          mostrarModales = false;
          return mostrarModales;
        }
      }
    }

    return mostrarModales;
  };
  const handleValidForm = () => {
    let isValid = true;
    let validaciones = [];

    const dataKeys = Object.keys(formData);

    dataKeys.forEach(dataKey => {
      const valor = formData[dataKey];
      pasos.forEach(paso => {
        paso.preguntas.forEach(p => {
          validaciones = validaciones.concat(
            formValidDatosPersonales(p, valor, dataKey),
          );
        });
      });
    });

    const camposConError = validaciones.map(validacion => validacion.campo);

    const formDataErrors = dataKeys.reduce((errors, dataKey) => {
      const campoTieneError = camposConError.includes(dataKey);
      return { ...errors, [`${dataKey}Error`]: campoTieneError };
    }, {});

    //Esto se hizo ya que se tuvo problemas con el campo de fecha de viaje parece que se traiga desde varios formularios atras y lo validaba cuando no es asi.
    validaciones = validaciones.filter(({ campo }) => {
      return campo !== 'fechaViaje';
    });

    if (validaciones.length === 1 && validaciones[0].campo === 'beneficiarios')
      setModalBeneficiarios(true);

    setFormDataError(formDataErrors);
    isValid = validaciones.length === 0;
    if (!isValid) {
      // setModal(true);
      // setTimeout(() => {
      //   setModal(false);
      // }, 3500);
    } else {
      setModal(false);
    }

    return isValid;
  };

  const handleSinBeneficiarios = () => {
    setModalBeneficiarios(false);

    handleConfirmar();
  };

  const renderValueIdentidad = identificacion => {
    switch (identificacion) {
      case 'Nacional':
        return '0';
      default:
        return identificacion;
    }
  };

  const { data } = useGetSeguros();

  const seguroSelected = data.data?.find(
    seguro => seguro.codigo === dataCotizar?.seguro?.codigo,
  );

  async function handleValidar(dependientes = []) {
    const mostrarModales = await handleSubmit(dependientes);

    if (mostrarModales) {
      return handleConfirmar();
    }
  }

  async function handleConfirmar() {
    setShowAlert(false);
    setModal(false);
    const segurosValidos = new Set([
      'SEG-AEG',
      'SEG-VID',
      'SEG-ONC',
      'SEG-PLENI',
      'SEG-PLENI-HILC',
    ]);

    if (segurosValidos.has(dataCotizar.seguro.codigo)) {
      setModales(true);
    } else if (seguroSelected?.OTPValidate) {
      mostrarModalOTP();
    } else {
      setModalRequisitos(true);
    }
  }

  const generateCodeOTP = useGenerateOTP();
  function mostrarModalOTP() {
    generateCodeOTP.mutate(paramsCodeOTP, {
      onSuccess: data => {
        if (data?.data?.isVerificated) {
          setModalRequisitos(true);
          setModales(false);
        } else {
          setOpenModalOTP(true);
        }
      },
    });
  }

  const aceptacionModal = aceptacion => {
    if (aceptacion && seguroSelected?.OTPValidate) {
      mostrarModalOTP();
    } else if (aceptacion) {
      setModalRequisitos(true);
      setModales(false);
    }
  };

  const aceptacionVerificarModalOTP = aceptacion => {
    if (aceptacion) {
      setModalRequisitos(true);
      setOpenModalOTP(false);
      setModales(false);
    }
  };

  return (
    <>
      {(dataCotizar.seguro.codigo === 'SEG-AEG' ||
        dataCotizar.seguro.codigo === 'SEG-VID') &&
      modales ? (
        <ModalEnfermedades
          open={modales}
          setOpen={setModales}
          aceptacionModal={aceptacionModal}
        />
      ) : dataCotizar.seguro.codigo === 'SEG-ONC' && modales ? (
        <ModalOncologico
          open={modales}
          setOpen={setModales}
          aceptacionModal={aceptacionModal}
        />
      ) : (dataCotizar.seguro.codigo === 'SEG-PLENI' || dataCotizar.seguro.codigo === 'SEG-PLENI-HILC') && modales ? (
        <ModalPleniSalud
          open={modales}
          setOpen={setModales}
          aceptacionModal={aceptacionModal}
          setPreexistencias={setPreexistencias}
          defaultValues={dataCotizar?.valoresModales?.ENFPRE || []}
        />
      ) : null}

      {openModalOTP && (
        <ModalSmsCode
          open={openModalOTP}
          setOpen={setOpenModalOTP}
          aceptacionVerificarModalOTP={aceptacionVerificarModalOTP}
          paramsCodeOTP={paramsCodeOTP}
        />
      )}

      <AlertCustom
        title={alert.title}
        description={alert.description}
        open={modal}
        setOpen={setModal}
        severity={alert.severity}
      />
      {cargando && <LoaderCotizar />}
      <div className="mx-auto container mb-10 mt-5 container-datos-personales px-6 md:px-0 xl:px-56">
        <TextCustom
          text="Confirma tus datos"
          variant="h1"
          component="h2"
          className="fontPSemiBold color-primary text-[22px] md:text-[40px] text-center mb-3"
        />
        <TextCustom
          text={`Para la emisión de tu ${
            dataCotizar?.seguro?.nombre.includes('Seguro')
              ? `${dataCotizar?.seguro?.nombre}`
              : `seguro ${dataCotizar?.seguro?.nombre}`
          } confirma que todos tus datos estén correctos.`}
          variant="p"
          component="p"
          className="fontPRegular color-primary text-center text-sm md:text-base"
        />
        <div className="text-center flex flex-wrap grid-form relative">
          {pasos[paso - 1]?.preguntas?.map((pregunta, index) => {
            return (
              <PreguntasForm
                titulo={pregunta?.titulo}
                tipoDato={pregunta?.tipo_dato?.tipo}
                valueForm={pregunta?.value}
                action={handleValue}
                mostrarError={formDataError[pregunta.value + 'Error']}
                msgError={pregunta?.msgError}
                placeholder={pregunta?.placeholder}
                respuestas={pregunta?.respuestas}
                key={index}
                loader={loaderInput}
                mostrarCampos={mostrarCampos}
                className={'form-left'}
                descripcion={pregunta?.descripcion}
                value={formData[pregunta.value]}
                alignError="left"
                formatTel={maskTel}
                classNamePrincipal={
                  pregunta?.value === 'beneficiarios' ||
                  pregunta?.value === 'dependientes'
                    ? 'w-full'
                    : 'w-full lg:w-[48%] h-auto'
                }
                handleSubmit={handleValidar}
                isPasoEmision={true}
                formData={formData}
              />
            );
          })}
        </div>

        {(dataCotizar?.seguro?.codigo !== 'SEG-PLENI' && dataCotizar?.seguro?.codigo !== 'SEG-PLENI-HILC') ? (
          seguroSelected?.OTPValidate && formData.telefono ? (
            <div className="text-primary-content text-base w-full text-center -mt-16 pb-7 ">
              Te enviaremos un mensaje de texto de verificación en los
              siguientes pasos al número:&nbsp;
              <b>
                {formData.telefono || dataCotizar.datosPersonales?.telefono}
              </b>
            </div>
          ) : null
        ) : (
          ''
        )}

        {/* {dataCotizar?.seguro?.codigo !== 'SEG-PLENI' ? ( */}
          <div className="flex flex-col justify-center items-center">
            
            <ButtonCustom
              disabled={cargando ? true : false}
              text="Confirmar"
              width="180px"
              onClick={handleValidar}
            />
            <ButtonCustom
              text="Regresar"
              variant="text"
              className="color-primary fontPSemiBold text-base  mt-3 cursor-pointer underline  lg:text-lg hover:bg-transparent"
              onClick={handleRegresarPaso}
              typeColor="general"
            />
          </div>
        {/* ) : (
          ''
        )} */}
        <ModalControlValidacion
          open={modalValidacion}
          setOpen={setModalValidacion}
          titulo="¡Verificación necesaria!"
          contenido="En este momento no podemos proceder debido a una revisión de nuestros registros"
          contactar={renderContactarControlValidacion()}
        />

        <ModalTerminos
          open={modalRequisitos}
          setOpen={setModalRequisitos}
          titulo="Aceptación: Perfeccionamiento del contrato y declaración jurada emisión de Pólizas"
          aceptacionModal={aceptacionModalEmisionPoliza}
          contenido={renderBoldText()}
        />
        <ModalAlertas
          open={modalBeneficiarios}
          // setOpen={(open)=>changeModalOpen('beneficiarios', open)}

          setOpen={setModalBeneficiarios}
          severity="info"
          contenido="Es importante declarar uno o más beneficiarios al adquirir tu seguro."
          onClose={true}
          aceptacionModal={handleSinBeneficiarios}
          title="Agrega beneficiarios"
        />

        <ModalAlertas
          open={modalPorcentaje}
          setOpen={setModalPorcentaje}
          severity="warning"
          contenido={mensajeError.mensaje}
          title={mensajeError.titulo}
        />
      </div>

      <AlertCustom
        title="¡Número de identificación incorrecto!"
        description="Las identidades deben ser diferentes."
        open={showAlert}
        setOpen={setShowAlert}
        severity="error"
      />
    </>
  );
};

export default PasoEmision;
